import React, { Component } from 'react';

export default class JsonInput extends Component {

  componentDidMount() {
    this.refInput.select();
  }

  render() {
    const { value, ...rest } = this.props;
    const chars = `${value}`.length || 0.25;

    return <input ref={c => { this.refInput = c; }} style={{ width: `${chars}ch`}} value={value}  {...rest} autoFocus/>;
  }

}
